export class Supplier {
  public Id: number;
  public Name: string;
  public BusinessDescription: string;
}
